"use client";
import React from "react";
export const AppContext = React.createContext({});
export default AppContext;
